import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppFloatButton from '@/components/WhatsAppFloatButton';
import GridBackground from '@/components/GridBackground';
import SEO from '@/components/SEO';

export default function About() {
  return (
    <div className="relative min-h-screen bg-background overflow-hidden">
      <SEO
        fullTitle="About Jotunheims FZCO | Technology Company in Dubai"
        description="Jotunheims FZCO is a UAE technology holding group in Dubai Silicon Oasis, led by founder Nelson M. Acevedo, building AI, software and cybersecurity products."
        path="/about"
      />
      <GridBackground />
      <Navbar />

      <main className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 pt-36 pb-24">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-4xl md:text-5xl font-inter font-bold tracking-tight text-foreground mb-8"
        >
          About Jotunheims FZCO: A Technology Studio in Dubai
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="space-y-6 text-muted-foreground font-inter leading-relaxed text-base md:text-lg"
        >
          <p className="flex flex-wrap gap-4 text-sm">
            <Link to="/founder" className="text-primary hover:underline">Founder →</Link>
            <Link to="/services" className="text-primary hover:underline">Services →</Link>
            <Link to="/prices" className="text-primary hover:underline">Prices →</Link>
          </p>
          <p>
            Jotunheims FZCO is a technology company in Dubai Silicon Oasis, UAE. It is a technology holding group founded on a simple mission: powering
            innovation while empowering the people and businesses we work with. Headquartered in Dubai
            Silicon Oasis, we operate as a multi-disciplinary studio that designs, builds, and scales digital
            products across AI solutions, custom software development, websites, mobile applications,
            cybersecurity, and independent digital ventures.
          </p>
          <p>
            Our platform exists to help ambitious brands, startups, and entrepreneurs move faster without
            sacrificing quality. Whether a client needs a production-ready web application, a mobile app
            launched across iOS and Android, an AI-powered assistant integrated into their operations, or a
            hardened security posture protecting their infrastructure, our teams bring the technical depth to
            deliver it end-to-end. We also incubate and operate our own self-funded ventures, applying the
            same engineering discipline we bring to client work to build products we believe in.
          </p>
          <p>
            Jotunheims is built and led by Nelson M. Acevedo, Founder &amp; CEO, together with a distributed
            team of engineers, designers, and security specialists who share a commitment to shipping
            reliable, well-crafted technology. We combine startup speed with enterprise-grade rigor, and we
            measure success by the outcomes our clients and ventures achieve, not just the code we ship.
          </p>
          <p>
            If you are a founder, operator, or enterprise looking for a technology partner who can take an
            idea from concept to a fully operational product, Jotunheims is built for exactly that.
          </p>
        </motion.div>
      </main>

      <Footer />
      <WhatsAppFloatButton />
    </div>
  );
}